export const clubGiftsGaloreAssets = {
	v1: {
		card: {
			box: "/spec_club_gifts_galore/box.png",
			rewardBackground: "/spec_club_gifts_galore/item-bg.png",
			starBurst: "/spec_club_gifts_galore/star-burst.png"
		},
		giftBoxes: {
			starBurst: "/spec_club_gifts_galore/start-burst-reward.png"
		},
		popups: {
			earnedReward: {
				backgroundDesktop: "/spec_club_gifts_galore/earned-reward-desktop.png",
				backgroundMobile: "/spec_club_gifts_galore/earned-reward-mobile.png",
				title: "/spec_club_gifts_galore/title.png",
				titleMobile: "/spec_club_gifts_galore/title-mobile.png"
			}
		}
	},
	v2: {
		card: {
			arrowBack: "/spec_club_gifts_galore/v2/arrow-back.png",
			arrowForward: "/spec_club_gifts_galore/v2/arrow-forward.png",
			box: "/spec_club_gifts_galore/v2/box-small.png",
			charLeft: "/spec_club_gifts_galore/v2/char-left.png",
			charRight: "/spec_club_gifts_galore/v2/char-right.png",
			starBurst: "/spec_club_gifts_galore/v2/start-burst-reward.png",
			tierTitle: "/spec_club_gifts_galore/v2/tier-title.png"
		},
		giftBoxes: {
			firstTimeBadge: "/spec_club_gifts_galore/v2/first-time-badge.png",
			starBurstViolet:
				"/spec_club_gifts_galore/v2/start-burst-reward-violet.png"
		},
		popups: {
			shared: {
				background: "/spec_club_gifts_galore/v2/bg-popup.jpg",
				title: "/spec_club_gifts_galore/v2/title.png"
			},
			moreInfo: {
				background: "/spec_club_gifts_galore/bg-pop-up.png"
			},
			tier: {
				background: "/spec_club_gifts_galore/v2/new-tier-background.jpg"
			},
			notYetContributed: {
				backgroundLandscape:
					"/spec_club_gifts_galore/v2/bg-not-contributed-yet-landscape.jpg",
				backgroundPortrait:
					"/spec_club_gifts_galore/v2/bg-not-contributed-yet-portrait.jpg"
			}
		}
	}
} as const;
